import { render, staticRenderFns } from "./dangerousGoodsList.vue?vue&type=template&id=223887f3&"
import script from "./dangerousGoodsList.vue?vue&type=script&lang=js&"
export * from "./dangerousGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports